import React, { useState } from "react";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/style/style.scss";
import App from "./app/App";
import HomePage from "./app/pages/homepage";
import base from "./app/components/firebase/config";
import * as firebase from "firebase/app";
import "firebase/auth";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

const Root = () => {
  const [userId, setUserId] = useState(false);

  firebase.auth().onAuthStateChanged(function (user) {
    if (user) {
      // User is signed in.
      setUserId(user.uid);
    }
  });

  return (
    <Router basename="/projets/tfe">
      <Switch>
        <Route path="/app">
          <App userId={userId} />
        </Route>
        <Route path="">
          <HomePage userId={userId} />
        </Route>
      </Switch>
    </Router>
  );
};

ReactDOM.render(<Root />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
